import { render } from "./ProsesAduanMasyarakat.vue?vue&type=template&id=7983b37c"
import script from "./ProsesAduanMasyarakat.vue?vue&type=script&lang=js"
export * from "./ProsesAduanMasyarakat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__